import { adminHttpClient } from '../../commons/adminHttpClient'
import { NamedItem } from 'domain/common/namedItem'

export interface SaveProspectRequest {
  companyName: string
  firstName: string
  lastName: string
  email: string
  secondaryEmails: string[]
  expirationDate: NamedItem
  jobTitle: string
  isAle: boolean
}

const saveProspect = (request: SaveProspectRequest): Promise<string> =>
  adminHttpClient.post(`/IchraDecisionTool/Prospects`, request)

export default saveProspect
